<!-- 我的卡券-->
<template>
    <div class="root-wrap">
        <div class="header-wrap">
            <van-button block @click="showAdd = true">
                <template #icon>
                    <van-icon name="add-o" :color="$config.style.primaryColor"></van-icon>
                </template>
                <span>添加贵宾卡</span>
            </van-button>
        </div>
        <div class="body-wrap fx-fill">
            <div class="fill-box" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="0">
                <user-card v-for="item, index in vipCardList" :key="index" :card="item" @click-info="showInfoDialog" :info="false"></user-card>
            </div>
        </div>
        <div class="utils-wrap">
            <user-card-dialog v-model="showAdd" @confirm="confirmAdd"></user-card-dialog>
        </div>
    </div>
</template>

<script>
import UserCard from '@/components/user/user-card';
import UserCardDialog from '@/components/user/user-card-dialog';
export default {
    data() {
        return {
            activeIndex: 0,
            list: [],
            pagination: this.$config.getDefaultPagination(),
            showAdd: false,
            showInfo: false,
            cardInfo: null,
            cardName: null,
        }
    },
    computed: {
        vipCardList() {
            if (!this.list) return [];
            return this.list.map((item) => {
                return {
                    ...item,
                    type: 'V'
                }
            })
        }
    },
    methods: {
        showInfoDialog(card, cardName) {
            this.cardName = cardName;
            this.$service.getCouponInfo({ cardno: card.cardno }).then((res) => {
                this.cardInfo = res;
                this.showInfo = true;
            });
        },
        getVipList() {
            let params = {
                type: 'VIP',
                page_no: this.pagination.current_page,
                per: 100,
            }
            this.$service.getMemberVipList(params).then((res) => {
                this.list = res.couponlist;
                this.list.sort((last) => last.status == 'L' ? 1 : -1)
                this.pagination = res.pagination;
            });
        },
        loadMore() {
            if (this.pagination.next) {
                ++this.pagination.current_page;
                if (this.activeIndex == 0) {
                    this.getACouponList();
                } else if (this.activeIndex == 1) {
                    this.getDCouponList();
                }
            }
        },
        confirmAdd(val) {
            let loading = this.$toast.loading('绑定中');
            let params = {
                cardpass: val,
                showtype: 'Y'
            }
            this.$service.bindCoupon(params).then((res) => {
                let type = res.type;
                loading.clear();
                this.initPage(type);
            })
        },
        initPage() {
            this.pagination = this.$config.getDefaultPagination();
            this.getVipList();
        }
    },
    mounted() {
        this.initPage();
    },
    components: {
        UserCard,
        UserCardDialog
    }
}
</script>

<style lang="scss" scoped>
.header-wrap {
	padding: 7px;
}
.body-wrap {
	position: relative;
	height: 0px;
	overflow: hidden;
	> .fill-box {
		padding: 0 7px;
	}
}
</style>